import { render, staticRenderFns } from "./TradesmanList.vue?vue&type=template&id=d342b234&"
import script from "./TradesmanList.vue?vue&type=script&lang=js&"
export * from "./TradesmanList.vue?vue&type=script&lang=js&"
import style0 from "./TradesmanList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports